/**
 * 原生 app 的对外标识。
 *
 * 曾经标着 AUTO-GENERATED，生成器在一个已废弃的仓库里 —— 本仓没有任何脚本会重写它，
 * 所以现在是**手工维护**：包名/商店地址变了要直接改这里。
 * KMP 侧同源引用见 `kmp-app/shared/src/androidMain/.../AppUpdate.android.kt`。
 */
export const ANDROID_PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.edwealth.ai";
